export const PAGES_API = import.meta.env.VITE_PAGES_API;
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const BASE_DOMAIN = import.meta.env.VITE_DOMAIN;
export const MONO_API = import.meta.env.VITE_MONO_API;
export const EMBEDS_URL = import.meta.env.VITE_EMBEDS_URL;
export const LAMBDA_AUTH_HEADER_VALUE = import.meta.env.VITE_LAMBDA_AUTH_HEADER_VALUE;
export const LAMBDA_AUTH_HEADER = import.meta.env.VITE_LAMBDA_AUTH_HEADER;
export const ASSETS_CDN_URL = import.meta.env.VITE_ASSETS_CDN_URL;
export const CONDUIT_API_URL = import.meta.env.VITE_CONDUIT_API_URL;
export const CONDUIT_API_KEY = import.meta.env.VITE_CONDUIT_API_KEY;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE;

export const NODE_ENV = import.meta.env.VITE_NODE_ENV;
export const COMMIT_HASH = import.meta.env.VITE_COMMIT_HASH;
